import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";

const getSid = () => {
  let s = localStorage.getItem("pp_sid");
  if (!s) {
    s = (typeof crypto !== "undefined" && crypto.randomUUID)
      ? crypto.randomUUID()
      : `s_${Date.now()}_${Math.random().toString(36).slice(2)}`;
    localStorage.setItem("pp_sid", s);
  }
  return s;
};

export const PresenceTracker = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (pathname.startsWith("/admin") || pathname.startsWith("/accedi")) return;
    const beat = () => {
      api.post("/presence/heartbeat", { session_id: getSid(), path: pathname }).catch(() => {});
    };
    beat();
    const iv = setInterval(beat, 15000);
    return () => clearInterval(iv);
  }, [pathname]);

  return null;
};
